module.exports = __webpack_public_path__ + "static/circlepng-aa2031048e683cc0b656ac012451966a.png";